var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "nav",
    { attrs: { role: "navigation" } },
    [
      _c(
        "Box",
        [
          _c("UIInput", {
            attrs: { placeholder: "Search menu", clearable: true },
            model: {
              value: _vm.navSearch,
              callback: function($$v) {
                _vm.navSearch = $$v
              },
              expression: "navSearch"
            }
          })
        ],
        1
      ),
      _c(
        "ScrollablePanel",
        [
          _c("NavSection", { attrs: { title: "Dashboards" } }, [
            _c("ul", { class: { close: _vm.dashboardSection } }, [
              _vm.currentUser.type === "Accounting" &&
              _vm.matchesSearch("Reports")
                ? _c(
                    "li",
                    [
                      _c(
                        "RouterLink",
                        {
                          attrs: {
                            to: `/dashboards/${_vm.currentUser.id}/reports`
                          }
                        },
                        [_vm._v("Reports")]
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.currentUser.type === "DataServices" &&
              _vm.matchesSearch("Receipts Summary")
                ? _c(
                    "li",
                    [
                      _c(
                        "RouterLink",
                        {
                          attrs: {
                            to: `/dashboards/${_vm.currentUser.id}/receipts-summary`
                          }
                        },
                        [_vm._v("Receipts Summary")]
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.currentUser.type !== "Accounting" &&
              _vm.currentUser.type !== "DataServices" &&
              _vm.matchesSearch("Summary")
                ? _c(
                    "li",
                    [
                      _c(
                        "RouterLink",
                        {
                          attrs: {
                            to: `/dashboards/${_vm.currentUser.id}/summary`
                          }
                        },
                        [_vm._v("Summary")]
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.matchesSearch("Advanced Search")
                ? _c(
                    "li",
                    [
                      _c("RouterLink", { attrs: { to: "/search" } }, [
                        _vm._v("Advanced Search")
                      ])
                    ],
                    1
                  )
                : _vm._e(),
              _vm.matchesSearch("My Donor Lists")
                ? _c(
                    "li",
                    [
                      _c("RouterLink", { attrs: { to: "/donor-list" } }, [
                        _vm._v("My Donor Lists")
                      ])
                    ],
                    1
                  )
                : _vm._e(),
              _vm.showNotificationSettings &&
              _vm.matchesSearch("Email Notifications")
                ? _c(
                    "li",
                    [
                      _c("RouterLink", { attrs: { to: "/notifications" } }, [
                        _vm._v("Email Notifications")
                      ])
                    ],
                    1
                  )
                : _vm._e(),
              _vm.matchesSearch("Retention Reports")
                ? _c(
                    "li",
                    [
                      _c("RouterLink", { attrs: { to: "/retention" } }, [
                        _vm._v("Retention Reports")
                      ])
                    ],
                    1
                  )
                : _vm._e(),
              _vm.matchesSearch("Dynamic Reports")
                ? _c(
                    "li",
                    [
                      _c("RouterLink", { attrs: { to: "/dynamic-reports" } }, [
                        _vm._v("Dynamic Reports")
                      ])
                    ],
                    1
                  )
                : _vm._e(),
              _vm.hasRole(_vm.UserRole.ViewLeadershipReports) &&
              _vm.matchesSearch("Leadership Reports")
                ? _c(
                    "li",
                    [
                      _c(
                        "RouterLink",
                        { attrs: { to: "/leadership-reports" } },
                        [_vm._v("Leadership Reports")]
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.matchesSearch("Pipeline")
                ? _c(
                    "li",
                    [
                      _c("RouterLink", { attrs: { to: "/pipeline" } }, [
                        _vm._v("Pipeline")
                      ])
                    ],
                    1
                  )
                : _vm._e(),
              _vm.matchesSearch("Fundraiser Library")
                ? _c(
                    "li",
                    [
                      _c("RouterLink", { attrs: { to: "/library" } }, [
                        _vm._v("Fundraiser Library")
                      ])
                    ],
                    1
                  )
                : _vm._e(),
              _vm.hasRole(_vm.UserRole.ViewTeachDashboard) &&
              _vm.matchesSearch("Teach Fundraising")
                ? _c(
                    "li",
                    [
                      _c("RouterLink", { attrs: { to: "/teach-dashboard" } }, [
                        _vm._v("Teach Fundraising")
                      ])
                    ],
                    1
                  )
                : _vm._e(),
              _vm.matchesSearch("Open Pledges")
                ? _c(
                    "li",
                    [
                      _c("RouterLink", { attrs: { to: "/open-pledges" } }, [
                        _vm._v("Open Pledges")
                      ])
                    ],
                    1
                  )
                : _vm._e(),
              _vm.matchesSearch("Goals Report") &&
              (_vm.currentUser.type !== "Fundraiser" ||
                _vm.hasRole(_vm.UserRole.ViewGoalsReport))
                ? _c(
                    "li",
                    [
                      _c("RouterLink", { attrs: { to: "/goals-report" } }, [
                        _vm._v("Goals Report")
                      ])
                    ],
                    1
                  )
                : _vm._e(),
              _vm.currentUser.type !== "Fundraiser" &&
              _vm.matchesSearch("Debt Report")
                ? _c(
                    "li",
                    [
                      _c("RouterLink", { attrs: { to: "/debt-report" } }, [
                        _vm._v("Debt Report")
                      ])
                    ],
                    1
                  )
                : _vm._e(),
              _vm.matchesSearch("OU Fundraising") &&
              (_vm.currentUser.type !== "Fundraiser" ||
                _vm.hasRole(_vm.UserRole.ViewOuFundraisingDashboard))
                ? _c(
                    "li",
                    [
                      _c("RouterLink", { attrs: { to: "/ou-fundraising" } }, [
                        _vm._v("OU Fundraising")
                      ])
                    ],
                    1
                  )
                : _vm._e(),
              (_vm.currentUser.type === "Accounting" ||
                _vm.hasRole(_vm.UserRole.ViewFundraisingBudget)) &&
              _vm.matchesSearch("Fundraising Budget")
                ? _c(
                    "li",
                    [
                      _c(
                        "RouterLink",
                        { attrs: { to: "/fundraising-budget" } },
                        [_vm._v("Fundraising Budget")]
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.hasRole(_vm.UserRole.ViewTelemarketing) &&
              _vm.matchesSearch("Telemarketing")
                ? _c(
                    "li",
                    [
                      _c("RouterLink", { attrs: { to: "/telemarketing" } }, [
                        _vm._v("Telemarketing")
                      ])
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "li",
                [
                  _c("RouterLink", { attrs: { to: "/voice-broadcast" } }, [
                    _vm._v("Voice Broadcast")
                  ])
                ],
                1
              ),
              _vm.hasRole(_vm.UserRole.ViewDirectMailProspects) &&
              _vm.matchesSearch("Direct Mail Prospects")
                ? _c(
                    "li",
                    [
                      _c(
                        "RouterLink",
                        { attrs: { to: "/direct-mail-prospects" } },
                        [_vm._v("Direct Mail Prospects")]
                      )
                    ],
                    1
                  )
                : _vm._e()
            ])
          ]),
          _c("NavSection", { attrs: { title: "Donor Management" } }, [
            _c("ul", [
              _c(
                "li",
                [
                  _vm.matchesSearch("All Donors")
                    ? _c("RouterLink", { attrs: { to: "/donors" } }, [
                        _vm._v("All Donors")
                      ])
                    : _vm._e(),
                  _vm.hasRole(_vm.UserRole.ManageBenefactor) &&
                  _vm.matchesSearch("Major Donors")
                    ? _c("RouterLink", { attrs: { to: "/benefactor" } }, [
                        _vm._v("Major Donors")
                      ])
                    : _vm._e(),
                  _vm.hasRole(_vm.UserRole.ManageBenefactor) &&
                  _vm.matchesSearch("MD Overview")
                    ? _c(
                        "RouterLink",
                        { attrs: { to: "/benefactor-members" } },
                        [_vm._v("MD Overview")]
                      )
                    : _vm._e(),
                  _vm.hasRole(_vm.UserRole.ManageEmployees) &&
                  _vm.matchesSearch("OU Employees")
                    ? _c("RouterLink", { attrs: { to: "/ouemployees" } }, [
                        _vm._v("OU Employees")
                      ])
                    : _vm._e(),
                  _vm.matchesSearch("Moves Management")
                    ? _c("RouterLink", { attrs: { to: "/moves" } }, [
                        _vm._v("Moves Management")
                      ])
                    : _vm._e(),
                  _vm.matchesSearch("Pledge Management")
                    ? _c("RouterLink", { attrs: { to: "/pledges" } }, [
                        _vm._v("Pledge Management")
                      ])
                    : _vm._e(),
                  _vm.matchesSearch("Planned Giving")
                    ? _c("RouterLink", { attrs: { to: "/pg" } }, [
                        _vm._v("Planned Giving")
                      ])
                    : _vm._e(),
                  _vm.matchesSearch("Campaigns")
                    ? _c("RouterLink", { attrs: { to: "/campaigns" } }, [
                        _vm._v("Campaigns")
                      ])
                    : _vm._e(),
                  _vm.hasRole(_vm.UserRole.ViewOuMemebers) &&
                  _vm.matchesSearch("OU Membership")
                    ? _c("RouterLink", { attrs: { to: "/ou-membership" } }, [
                        _vm._v("OU Membership")
                      ])
                    : _vm._e(),
                  _vm.belongsToTeachCoalition &&
                  _vm.matchesSearch("OUTeach Ambassador Networks")
                    ? _c("RouterLink", { attrs: { to: "/networks" } }, [
                        _vm._v("OUTeach Ambassador Networks")
                      ])
                    : _vm._e(),
                  _vm.belongsToTeachCoalition &&
                  _vm.matchesSearch("Ambassador Network Regions")
                    ? _c("RouterLink", { attrs: { to: "/regions" } }, [
                        _vm._v("Ambassador Network Regions")
                      ])
                    : _vm._e()
                ],
                1
              )
            ])
          ]),
          _vm.hasRole(_vm.UserRole.ManageBoardMembers)
            ? _c("NavSection", { attrs: { title: "Board Management" } }, [
                _c("ul", [
                  _c(
                    "li",
                    [
                      _vm.matchesSearch("Board Members")
                        ? _c("RouterLink", { attrs: { to: "/boardmembers" } }, [
                            _vm._v("Board Members")
                          ])
                        : _vm._e(),
                      _vm.matchesSearch("Directors & Governors")
                        ? _c("RouterLink", { attrs: { to: "/board-list" } }, [
                            _vm._v("Directors & Governors")
                          ])
                        : _vm._e(),
                      _vm.matchesSearch("Payments")
                        ? _c(
                            "RouterLink",
                            { attrs: { to: "/boardmembers-payments" } },
                            [_vm._v("Payments")]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ])
              ])
            : _vm._e(),
          _vm.hasRole(_vm.UserRole.ManageCommissionAndCommitteeMembers)
            ? _c("NavSection", { attrs: { title: "Commission Management" } }, [
                _c("ul", [
                  _vm.matchesSearch("Commission Members")
                    ? _c(
                        "li",
                        [
                          _c(
                            "RouterLink",
                            { attrs: { to: "/commission-members" } },
                            [_vm._v("Commission Members")]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.matchesSearch("Payments")
                    ? _c(
                        "li",
                        [
                          _c(
                            "RouterLink",
                            { attrs: { to: "/commission-member/payments" } },
                            [_vm._v("Payments")]
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ])
              ])
            : _vm._e(),
          _vm.hasRole(_vm.UserRole.ManageCommissionAndCommitteeMembers)
            ? _c("NavSection", { attrs: { title: "Committee Management" } }, [
                _c("ul", [
                  _vm.matchesSearch("Committee Members")
                    ? _c(
                        "li",
                        [
                          _c(
                            "RouterLink",
                            { attrs: { to: "/committee-members" } },
                            [_vm._v("Committee Members")]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.matchesSearch("Payments")
                    ? _c(
                        "li",
                        [
                          _c(
                            "RouterLink",
                            { attrs: { to: "/committee-member/payments" } },
                            [_vm._v("Payments")]
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ])
              ])
            : _vm._e(),
          _c("NavSection", { attrs: { title: "Foundations" } }, [
            _c("ul", [
              _vm.matchesSearch("All Foundations")
                ? _c(
                    "li",
                    [
                      _c("RouterLink", { attrs: { to: "/foundations" } }, [
                        _vm._v("All Foundations")
                      ])
                    ],
                    1
                  )
                : _vm._e(),
              _vm.matchesSearch("Foundations Report")
                ? _c(
                    "li",
                    [
                      _c(
                        "RouterLink",
                        { attrs: { to: "/foundations/report" } },
                        [_vm._v("Foundations Report")]
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.matchesSearch("Grants")
                ? _c(
                    "li",
                    [
                      _c("RouterLink", { attrs: { to: "/grants" } }, [
                        _vm._v("Grants")
                      ])
                    ],
                    1
                  )
                : _vm._e(),
              _vm.matchesSearch("Grant Ideas")
                ? _c(
                    "li",
                    [
                      _c("RouterLink", { attrs: { to: "/grant-ideas" } }, [
                        _vm._v("Grant Ideas")
                      ])
                    ],
                    1
                  )
                : _vm._e()
            ])
          ]),
          _vm.showDS
            ? _c("NavSection", { attrs: { title: "Data Services" } }, [
                _c("ul", [
                  _c(
                    "li",
                    [
                      _vm.isDS && _vm.matchesSearch("Batch Reconciliation")
                        ? _c(
                            "RouterLink",
                            { attrs: { to: "/reconciliation" } },
                            [_vm._v("Batch Reconciliation")]
                          )
                        : _vm._e(),
                      _vm.isDS &&
                      _vm.matchesSearch("Batch Reconciliation Cardknox")
                        ? _c(
                            "RouterLink",
                            { attrs: { to: "/reconciliation-cardknox" } },
                            [_vm._v("Batch Reconciliation Cardknox")]
                          )
                        : _vm._e(),
                      _vm.isDS && _vm.matchesSearch("Fundraiser Actions")
                        ? _c(
                            "RouterLink",
                            { attrs: { to: "/fundraiser-actions" } },
                            [_vm._v("Fundraiser Actions")]
                          )
                        : _vm._e(),
                      _vm.hasRole(_vm.UserRole.ViewNewDonors) &&
                      _vm.matchesSearch("Confirm Households")
                        ? _c(
                            "RouterLink",
                            { attrs: { to: "/dataservices/newhouseholds" } },
                            [_vm._v("Confirm Households")]
                          )
                        : _vm._e(),
                      _vm.isDS && _vm.matchesSearch("DAFPay")
                        ? _c("RouterLink", { attrs: { to: "/dafpay" } }, [
                            _vm._v("DAFPay")
                          ])
                        : _vm._e(),
                      (_vm.hasRole(_vm.UserRole.ViewPending) ||
                        _vm.hasRole(_vm.UserRole.ManageRM)) &&
                      _vm.matchesSearch("Pending items")
                        ? _c(
                            "RouterLink",
                            {
                              attrs: {
                                to: _vm.hasRole(_vm.UserRole.ViewPending)
                                  ? "/dataservices/pending/pledges"
                                  : "/dataservices/pending/rm"
                              }
                            },
                            [_vm._v("Pending items")]
                          )
                        : _vm._e(),
                      _vm.isDS && _vm.matchesSearch("Pending Ach Payments")
                        ? _c(
                            "RouterLink",
                            { attrs: { to: "/pending-ach-payments" } },
                            [_vm._v("Pending Ach Payments")]
                          )
                        : _vm._e(),
                      _vm.isDS && _vm.matchesSearch("Checks")
                        ? _c(
                            "RouterLink",
                            { attrs: { to: "/dataservices/checks" } },
                            [_vm._v("Checks")]
                          )
                        : _vm._e(),
                      _vm.isDS && _vm.matchesSearch("Pledges Bulk Changes")
                        ? _c("RouterLink", { attrs: { to: "/bulk-pledge" } }, [
                            _vm._v("Pledges Bulk Changes")
                          ])
                        : _vm._e(),
                      _vm.isDS && _vm.matchesSearch("Payments Bulk Changes")
                        ? _c("RouterLink", { attrs: { to: "/bulk-payment" } }, [
                            _vm._v("Payments Bulk Changes")
                          ])
                        : _vm._e(),
                      _vm.hasRole(_vm.UserRole.ViewBatches) &&
                      _vm.matchesSearch("Batch Management")
                        ? _c("RouterLink", { attrs: { to: "/batches" } }, [
                            _vm._v("Batch Management")
                          ])
                        : _vm._e(),
                      _vm.isDS && _vm.matchesSearch("Payments")
                        ? _c("RouterLink", { attrs: { to: "/payments" } }, [
                            _vm._v("Payments")
                          ])
                        : _vm._e(),
                      (_vm.isDS ||
                        _vm.hasRole(_vm.UserRole.ViewRecurringPayments)) &&
                      _vm.matchesSearch("Recurring Payments")
                        ? _c(
                            "RouterLink",
                            { attrs: { to: "/recurring-payments" } },
                            [_vm._v("Recurring Payments")]
                          )
                        : _vm._e(),
                      _vm.isDS && _vm.matchesSearch("Pledges due Today")
                        ? _c(
                            "RouterLink",
                            { attrs: { to: "/pledges-today" } },
                            [_vm._v("Pledges due Today")]
                          )
                        : _vm._e(),
                      _vm.isDS && _vm.matchesSearch("Web Imports")
                        ? _c("RouterLink", { attrs: { to: "/webimports" } }, [
                            _vm._v("Web Imports")
                          ])
                        : _vm._e(),
                      _vm.isDS && _vm.matchesSearch("Priority Imports")
                        ? _c(
                            "RouterLink",
                            { attrs: { to: "/priority-imports" } },
                            [_vm._v("Priority Imports")]
                          )
                        : _vm._e(),
                      _vm.isDS && _vm.matchesSearch("Priority Sync")
                        ? _c(
                            "RouterLink",
                            { attrs: { to: "/dataservices/priority-sync" } },
                            [_vm._v("Priority Sync")]
                          )
                        : _vm._e(),
                      _vm.currentUser.type === _vm.UserType.DataServices &&
                      _vm.matchesSearch("Nova Matching Activity")
                        ? _c(
                            "RouterLink",
                            { attrs: { to: "/dataservices/nova-matching" } },
                            [_vm._v("Nova Matching Activity")]
                          )
                        : _vm._e(),
                      _vm.matchesSearch("Department Management")
                        ? _c("RouterLink", { attrs: { to: "/departments" } }, [
                            _vm._v("Department Management")
                          ])
                        : _vm._e(),
                      _vm.isDS && _vm.matchesSearch("Users")
                        ? _c("RouterLink", { attrs: { to: "/users" } }, [
                            _vm._v("Users")
                          ])
                        : _vm._e(),
                      _vm.hasRole(_vm.UserRole.ViewQiuckLookup) &&
                      _vm.matchesSearch("Quick Lookup")
                        ? _c("RouterLink", { attrs: { to: "/lookup" } }, [
                            _vm._v("Quick Lookup")
                          ])
                        : _vm._e(),
                      _vm.isDS && _vm.matchesSearch("Duplicates Management")
                        ? _c("RouterLink", { attrs: { to: "/duplicates" } }, [
                            _vm._v("Duplicates Management")
                          ])
                        : _vm._e(),
                      _vm.canGenerateInvoicesAndReceipts() &&
                      _vm.matchesSearch("Generate invoices & receipts")
                        ? _c(
                            "RouterLink",
                            { attrs: { to: "/generateinvoice" } },
                            [_vm._v("Generate invoices & receipts")]
                          )
                        : _vm._e(),
                      _vm.isDS && _vm.matchesSearch("Generate Membership Cards")
                        ? _c(
                            "RouterLink",
                            { attrs: { to: "/generate-membership-cards" } },
                            [_vm._v("Generate Membership Cards")]
                          )
                        : _vm._e(),
                      _vm.isDS && _vm.matchesSearch("Canada Imports")
                        ? _c(
                            "RouterLink",
                            { attrs: { to: "/dataservices/canada-imports" } },
                            [_vm._v("Canada Imports")]
                          )
                        : _vm._e(),
                      _vm.isDS && _vm.matchesSearch("Excel Imports")
                        ? _c(
                            "RouterLink",
                            { attrs: { to: "/dataservices/xls-imports" } },
                            [_vm._v("Excel Imports")]
                          )
                        : _vm._e(),
                      _vm.isDS && _vm.matchesSearch("CDS Imports")
                        ? _c(
                            "RouterLink",
                            { attrs: { to: "/dataservices/cds-imports" } },
                            [_vm._v("CDS Imports")]
                          )
                        : _vm._e(),
                      (_vm.isDS ||
                        _vm.hasRole(_vm.UserRole.ViewCauseMatchImports)) &&
                      _vm.matchesSearch("CauseMatch Imports")
                        ? _c(
                            "RouterLink",
                            {
                              attrs: { to: "/dataservices/causematch-imports" }
                            },
                            [_vm._v("CauseMatch Imports")]
                          )
                        : _vm._e(),
                      _vm.isDS && _vm.matchesSearch("Solicitation Imports")
                        ? _c(
                            "RouterLink",
                            {
                              attrs: {
                                to: "/dataservices/solicitation-imports"
                              }
                            },
                            [_vm._v("Solicitation Imports")]
                          )
                        : _vm._e(),
                      (_vm.currentUser.type === "Accounting" ||
                        _vm.hasRole(_vm.UserRole.ManageNetsuiteMapping)) &&
                      _vm.matchesSearch("NetSuite Sync")
                        ? _c(
                            "RouterLink",
                            { attrs: { to: "/netsuite-sync" } },
                            [_vm._v("NetSuite Sync")]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ])
              ])
            : _vm._e(),
          _c("NavSection", { attrs: { title: "Data Cleanup" } }, [
            _c("ul", [
              _c(
                "li",
                [
                  _vm.matchesSearch("Missing Address")
                    ? _c("RouterLink", { attrs: { to: "/missing-address" } }, [
                        _vm._v("Missing Address")
                      ])
                    : _vm._e(),
                  _vm.matchesSearch("Missing Salutation")
                    ? _c(
                        "RouterLink",
                        { attrs: { to: "/missing-salutation" } },
                        [_vm._v("Missing Salutation")]
                      )
                    : _vm._e()
                ],
                1
              )
            ])
          ]),
          _c("br")
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }